import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import type { DocumentContentDetail } from '../types/documentIndexing';
import { keys } from './keys';

async function fetchDocumentContent(documentId: string): Promise<DocumentContentDetail> {
  const { data, error } = await apiClient
    .from('document_contents')
    .select('document_id, content, extracted_at')
    .eq('document_id', documentId)
    .single();

  if (error) {
    throw error;
  }

  return {
    documentId: data.document_id,
    content: data.content,
    extractedAt: data.extracted_at,
  };
}

export function useGetDocumentContent(documentId: string | null | undefined) {
  return useQuery({
    queryKey: keys.getDocumentContent(documentId ?? ''),
    queryFn: () => fetchDocumentContent(documentId!),
    enabled: Boolean(documentId),
  });
}

